<template>
    <div>
        <div class="panel-tag">
            {{__t('DB_PARAMS')}}
        </div>

        <div class="form-group" v-for="(key_val,key_name) in cur_db" v-if="key_name.length > 0 && key_name != 'id'">
            <label class="form-label">
                {{ __t(key_name.toUpperCase()) }}
            </label>

            <div class="input-group input-group-lg bg-white shadow-inset-2 with_icon">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-transparent border-left-0 border-right-0 py-1 px-3">
                        <span class="icon-stack fs-xxl">
                            <i class="base-7 icon-stack-3x color-primary-500"></i>
                            <i class="fal fa-database icon-stack-1x text-white"></i>
                        </span>
                    </span>
                </div>

                <b-form-input
                    debounce="300"
                    class="form-control  bg-transparent pl-5"
                    :key="key_name"
                    @update="on_change_value(key_name)"
                    :state=is_valid_key(cur_db[key_name])
                    v-model="cur_db[key_name]"
                    :id="'db_pos_param_' + key_name"
                >
                </b-form-input>
            </div>
        </div>
    </div>
</template>

<script>
import Info_field from "../../../../sys/info_field.vue";

export default {
    name: "pos_db",
    components: {Info_field},
    props : {
        'cur_db' : {
            type : Object
        },
    },
    data() {
        return {
            db_set : {
                "db_name":"",
                "host":"",
                "ip":"",
                "user":"",
                "password":""
            }
        }
    },

    methods : {
        on_change_value (val) {

        },

        is_valid_key(val) {

        },
    }
}
</script>


<style scoped>

</style>
